import { useEffect, useState } from "react"
import { Class } from "../../../../types/dataModel"
import useFetch from "../../../../hooks/useFetch"
import { API } from "../../../../common/Constants"
import PreLoader from "../../../../core/common/preLoader"
import { getAPIHeaders, isNotEmpty, toCamelCase } from "../../../../common/Utils"
import FormFooter from "../../../../core/common/formFooter"
import CommonSelectV2 from "../../../../core/common/commonSelectV2"

interface Props {
    courseClass: Class | undefined
    onSuccess: ()=> void
    currCoursesOpts: any[]
}

const ModifyClass = ({courseClass, onSuccess, currCoursesOpts}:Props) => {
    const [formClass, setFormClass] = useState<Class | undefined>(courseClass)
    const [msgBox, setMsgBox] = useState<any>({
      msg: "",
      error: false
    });
    const {isLoading, error, data, status, callFetch } = useFetch();

    useEffect(()=>{
      setFormClass(courseClass)
    },[courseClass])

    const reset = () => {
      resetMsgBox()
    }

    const resetMsgBox = () => {
      setMsgBox({
        msg: "",
        error: false
      })
    }

    useEffect(() => {
              if(data && status && status < 299){
                setMsgBox({msg: "Updated successfully", error: false})
                onSuccess()
              }
    }, [status]);
        
        
    useEffect(() => {
            if(error){
              if(error.response?.data){
                setMsgBox({msg: error.response?.data, error: true})
              } else{
                setMsgBox({msg: 'Something went wrong please try again later.', error: true})
              }
            }
    }, [error]);

    const handleSubmit = (event:any) => {
          event.preventDefault()
          if(!isNotEmpty(formClass?.batchName)){
            setMsgBox({msg: "Please provide name", error: true})
          } else if(!isNotEmpty(formClass?.batchSection)){
            setMsgBox({msg: "Please provide section", error: true})
          } else {
            setMsgBox({msg:"",error: false})
            callFetch(API.CLASS,
                  'PUT',
                  getAPIHeaders(),
                  null,
                  {
                      id: formClass?.batchId,
                      curriculumCourseId: formClass?.curriculumCourseId,
                      name: formClass?.batchName,
                      section: formClass?.batchSection,
                  }
              );
          }
    }

    return (
        <div className="modal-dialog modal-dialog-centered modal-md"
        data-bs-backdrop="static"
        data-bs-keyboard="false">
          <PreLoader showLoader={isLoading} />
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Class</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={reset}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Curriculum - Course <span className="text-danger"> *</span></label>
                    <CommonSelectV2
                      className='select'
                      options={currCoursesOpts}
                      onChange={(value)=>{
                        setFormClass({
                          ...formClass,
                          curriculumCourseId: parseInt(value)
                        })
                      }}
                      defaultValue={currCoursesOpts.find((el,idx)=>el.value === `${formClass?.curriculumCourseId}`)}
                      formatOptionLabel={(item)=>{
                        return (
                          <div className="p-2">
                          <h6>
                            {item?.data?.courseTitle}
                            <span
                              className={`ms-2 badge rounded-pill bg-${
                                item?.data?.curriculumStatus === "ACTIVE"
                                  ? "success"
                                  : item?.data?.curriculumStatus === "UPCOMING"
                                  ? "info"
                                  : "primary"
                              }`}
                            >
                              {toCamelCase(item?.data?.curriculumStatus)}
                            </span>
                          </h6>
                          <span className="text-gray fs-12"> {item?.data?.curriculumTitle}</span>
                        </div>
                        )
                      }}
                    />
                  </div>
                </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Batch Name <span className="text-danger"> *</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formClass?.batchName}
                        onChange={(e)=>{
                          setFormClass({
                            ...formClass,
                            batchName: e.target.value
                          })
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Section <span className="text-danger"> *</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formClass?.batchSection}
                        onChange={(e)=>{
                          setFormClass({
                            ...formClass,
                            batchSection: e.target.value
                          })
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <FormFooter
                  onCancel={reset}
                  onSave={handleSubmit}
                  error={msgBox.error}
                  message={msgBox.msg} 
                />
              </div>
            </form>
          </div>
      </div>
    )
}

export default ModifyClass